import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cx from 'classnames'

import Toggle from 'components/Toggle'
import { Input } from '@driftt/tide-core-legacy'
import Accordion from 'components/settings/Accordion'
import ClickThroughAccordion from 'components/settings/ClickThroughAccordion'
import InstallPage from 'components/Integration/pages/install'
import { ensureIsAdmin } from 'app/modules/access/helpers'
import { makeHasGate } from 'app/modules/gates/selectors'
import {
  isChatEnabled,
  embedPatchSuccess,
  isShowWidgetIfConvoHistoryEnabled,
} from 'app/modules/embed/selectors'
import WithNotifications from 'components/shared/notifications'

import { patchEmbed } from 'app/modules/embed/actions'

import style from './style.styl'

const CHANGE_SUCCESS_NOTIFICATION_MESSAGE = 'Your changes have been saved'

class ChatWidgetSettings extends Component {
  state = {
    isInstallOpen: false,
  }

  handleInstallToggle = () => {
    this.setState({ isInstallOpen: !this.state.isInstallOpen })
  }

  onAllowIncomingChatsToggled = event => {
    const { actions } = this.props
    const isEnabled = event.target.checked
    const operations = [
      {
        operation: 'set',
        property: 'chatEnabled',
        value: isEnabled,
      },
    ]
    actions.patchEmbed(operations)
  }

  onAllowShowIfChatHistory = () => {
    const { actions, isShowWidgetIfConvoHistoryEnabled } = this.props

    const isEnabled = !isShowWidgetIfConvoHistoryEnabled
    const operations = [
      {
        operation: 'set',
        property: 'theme.enableChatIfConversationHistory',
        value: isEnabled,
      },
    ]
    actions.patchEmbed(operations)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.embedPatchSuccess && !!this.props.embedPatchSuccess) {
      this.props.notifications.success(CHANGE_SUCCESS_NOTIFICATION_MESSAGE)
    }
  }

  render() {
    const { isInstallOpen } = this.state
    const { isChatEnabledInEmbed, isShowWidgetIfConvoHistoryEnabled } = this.props

    return (
      this.props.children || (
        <div className={cx(style.ChatWidget)}>
          <div className="chat-widget-section-title">Drift Widget</div>
          <div className="chat-widget-display">
            <div className="chat-widget-display-option--container">
              <div className="chat-widget-display--copy-container">
                <h1 className="chat-widget-display--title">Display the Drift Widget Icon</h1>
                <h2 className="chat-widget-display--description">
                  Allow incoming chats by displaying the Drift icon on your site. If you turn this setting
                  off, you can still trigger conversations with playbooks, but users will not be able to open new
                  conversations by clicking the icon.
                </h2>
              </div>
              <Toggle
                checked={isChatEnabledInEmbed}
                onChange={this.onAllowIncomingChatsToggled}
                className="chat-widget-display--section-toggle"
              />
            </div>
            {!isChatEnabledInEmbed && (
              <div className="chat-widget-display-option--container chat-widget-display--second-option">
                <Input
                  type='checkbox'
                  checked={isShowWidgetIfConvoHistoryEnabled}
                  onChange={this.onAllowShowIfChatHistory}
                  className="chat-widget-display--section-toggle"
                />
                <h2 className="chat-widget-display--description">
                  Display the Drift Widget Icon if the visitor has had a previous conversation or if they have been targeted by a bot.
                </h2>
              </div>
            )}
          </div>
          <Accordion
            className="chat-widget-settings--new"
            title="Hours & targeting"
            description="Customize when your Drift Widget displays to your customers and visitors"
            rightContent={<span>View</span>}
            locked
            onToggle={() => window.location = '/settings2/widget/hours-and-targeting'}
          />
          <Accordion
            className="chat-widget-settings--new"
            title="Default greeting"
            description="Customize how you greet your site visitors when they click on your Drift Widget"
            rightContent={<span>View</span>}
            locked
            onToggle={() => window.location = '/settings2/widget/default-greeting'}
          />
          <Accordion
            className="chat-widget-settings--new"
            title="Design"
            description="Stylize your design elements"
            rightContent={<span>View</span>}
            locked
            onToggle={() => window.location = '/settings2/widget/design'}
          />
          <Accordion
            className="chat-widget-settings--new"
            title="Advanced"
            description="Customize advanced settings like emails"
            rightContent={<span>View</span>}
            locked
            onToggle={() => window.location = '/settings2/widget/advanced'}
          />
          <Accordion
            className="chat-widget-settings--new"
            title="Cookie Sharing"
            description="Customize which domains on which Drift will share your site visitor's information"
            rightContent={<span>View</span>}
            locked
            onToggle={() => window.location = '/settings2/cookie-sharing'}
          />
          <Accordion
            title="Install"
            description="Get Drift on your website in minutes!"
            open={isInstallOpen}
            onToggle={this.handleInstallToggle}
          >
            <InstallPage />
          </Accordion>
        </div>
      )
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        patchEmbed,
      },
      dispatch
    ),
  }
}

const mapStateToProps = state => ({
  isChatEnabledInEmbed: isChatEnabled(state),
  embedPatchSuccess: embedPatchSuccess(state),
  isShowWidgetIfConvoHistoryEnabled: isShowWidgetIfConvoHistoryEnabled(state),
})

export default WithNotifications(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ensureIsAdmin(ChatWidgetSettings))
)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/index.js